import React from 'react'
import { Button } from 'antd'

const ValidateButton = (props) =>
    <Button type="primary" htmlType="submit">Valider</Button>

export default ValidateButton